// Auto-generated from card.spec.js
export default {
  "tagName": "ui-cards",
  "variations": [
    "doubling",
    "stackable",
    "spaced",
    "count"
  ],
  "attributes": [
    "doubling",
    "stackable",
    "spaced",
    "count"
  ],
  "optionAttributes": {
    "spaced": "spaced",
    "very-spaced": "spaced",
    "two": "count",
    "three": "count",
    "four": "count",
    "five": "count",
    "six": "count"
  },
  "propertyTypes": {
    "doubling": "boolean",
    "stackable": "boolean",
    "spaced": "string",
    "count": "string"
  },
  "allowedValues": {
    "spaced": [
      "spaced",
      "very-spaced"
    ],
    "count": [
      "two",
      "three",
      "four",
      "five",
      "six"
    ]
  }
};
